import React from 'react';

export default function () {
  return (
    <svg viewBox="0 0 258 158" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M47.032 47.302l-2.058-1.873c-7.31-6.629-12.135-11-12.135-16.365 0-4.371 3.434-7.806 7.806-7.806 2.47 0 4.84 1.15 6.387 2.966 1.547-1.816 3.917-2.966 6.386-2.966 4.372 0 7.807 3.435 7.807 7.806 0 5.365-4.826 9.736-12.135 16.379l-2.058 1.86z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="129.197"
          cy="148.278"
          fill="#F0F1F1"
          rx="59.124"
          ry="8.722"
        />
        <g fill="#BABFC0">
          <g transform="rotate(-180 98.175 33.799)">
            <ellipse cx="2.92" cy="37.796" rx="2.92" ry="2.907" />
            <path d="M13.12 0h6.588v8.722H13.12a4.361 4.361 0 1 1 0-8.722zM11.667 34.889h8.041v5.815h-8.041a2.907 2.907 0 1 1 0-5.815z" />
          </g>
          <g transform="translate(0 26.894)">
            <ellipse cx="2.92" cy="2.907" rx="2.92" ry="2.907" />
            <ellipse cx="64.964" cy="63.963" rx="2.92" ry="2.907" />
            <ellipse cx="43.796" cy="20.352" rx="2.92" ry="2.907" />
            <path d="M20.426 0h61.326v5.815H20.426a2.907 2.907 0 1 1 0-5.815zM75.164 26.167h6.588v8.722h-6.588a4.361 4.361 0 0 1 0-8.722zM73.71 61.056h8.042v5.814H73.71a2.907 2.907 0 1 1 0-5.815z" />
            <path d="M58.357 34.889h23.395v17.444H58.357a8.722 8.722 0 0 1 0-17.444z" />
          </g>
        </g>
        <g transform="translate(81.752)">
          <rect fill="#BABFC0" height="122.111" rx="5.839" width="94.891" />
          <rect
            fill="#FFF"
            height="110.481"
            rx="2.92"
            width="83.212"
            x="5.839"
            y="5.815"
          />
          <g fill="#F0F1F1">
            <path d="M23.358 98.852h48.175v5.815H23.358zM23.358 87.222h48.175v5.815H23.358zM23.358 75.593h48.175v5.815H23.358zM23.358 63.963h48.175v5.815H23.358z" />
          </g>
          <path d="M30 17h34.063v34.063H30z" />
          <use fill="#DC143C" fillRule="nonzero" xlinkHref="#a" />
        </g>
      </g>
    </svg>
  );
}
